export default __webpack_public_path__ + "static/img_software_outsourcing-ae552304741bea642062a253216d6463.png";